import React, { Component } from 'react';
import { Show, List, TabbedShowLayout, Tab, Datagrid,BooleanField, EditButton, TextField, ReferenceField, ReferenceManyField, DateField, TopToolbar, RefreshButton, ListButton } from 'react-admin';
import { CamelCaseField, ExpectedDateField } from '../digitalOrders/common';
import { Scrollbars } from 'react-custom-scrollbars';
import { getLocalStorageKey, CommonHeaderOption, RUN_TIME_API_ENDPOINT } from '../common/common';

// const topToolbarStyle = {
//     zIndex: 2,
//     display: 'inline-block',
//     float: 'right',
// };

const ShowActions = ({ basePath, data }) => (
    <TopToolbar>
        <RefreshButton />
        <ListButton basePath={basePath} />
    </TopToolbar>
)

const ShowTitle = ({ record }) => {
    return record && <span>Send Message </span>;
};

class SoSendMessageShow extends Component {
    constructor(props){
        super(props);
        this.state = {
            loadingShow: false
        }
    }

    render(){
        const { props, permissions, state } = this;
        console.log('xxxx',state, props.id);
    return (
        <Show actions={<ShowActions permissions={permissions} />} {...props} title={<ShowTitle />}>
        <TabbedShowLayout className="tab-scroll">
            <Tab label="Details" contentClassName="scrollTab">
                <TextField label="Purpose" source="purpose" allowEmpty />
                <TextField 
                // label="SMS Text" 
                source="text" allowEmpty />
                <TextField 
                // label="Target type" 
                source="target_type" allowEmpty />
                <TextField label="SMS length [eg. 2 (160 characters)]" source="so_sms_length" sortable={false} allowEmpty />
                <TextField label="Number of Sales Officers" source="targeted_sales_officers_count" />
                <TextField label="Number of SMS (Number of Sales Officers * SMS length)" source="number_of_messages" />
                <TextField label="Number of SMS sent successfully" source="notified_sales_officers_count" />
                <TextField label="Number of SMS sending failed" source="failed_sales_officers" allowEmpty />
                {/* <DateField label={'Created at'} source="created_at" allowEmpty /> */}
                <DateField 
                // label="Created At" 
                source="created_at" showTime />
            </Tab>
            <Tab label="Sales Officer List">
                <ReferenceManyField
                    addLabel={false}
                    reference="so_sms_blast_sold_to_list"
                    target="id"
                    className="tab-pagination"
                >
                    <List {...props} 
                    filterDefaultValues={{ id: props.id }} 
                    bulkActionButtons={false} exporter={false}>
                        <Datagrid className="tab-data-grid">
                            <TextField label="Sales Officer email" source="email" />
                            <TextField label="Sales Officer Name" source="name" />
                            <TextField label="Sales Officer Phone" source="phone" />
                            <BooleanField label="SMS status" source="send_status" />
                            <TextField label="SMS response" source="send_response" />
                        </Datagrid>
                    </List>
                </ReferenceManyField>
            </Tab>
        </TabbedShowLayout>
        </Show>
        );
    };
}

export default SoSendMessageShow;